import { api } from "../../app/api";
import { BASE_API } from "../../constants/apiUrls";
import {
  GetSupplierPaymentHistoryParams,
  GetSupplierPaymentHistoryResponseType,
} from "../../types/statements";

export const supplierPaymentHistoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentHistory: builder.query<
      GetSupplierPaymentHistoryResponseType,
      GetSupplierPaymentHistoryParams
    >({
      query: (params) => ({
        url: BASE_API.getPaymentHistory,
        params,
      }),
    }),
    // exportSupplierPaymentHistory: builder.query({
    //   query: (queryArgs) => ({
    //     url: BASE_API.exportSupplierPaymentHistory,
    //     ...queryArgs,
    //   }),
    // }),
  }),
});

export const {
  useGetPaymentHistoryQuery,
  // useExportSupplierPaymentHistoryQuery,
} = supplierPaymentHistoryApi;
